// Teacher DNA onboarding types. Each answer is posted as a question/answer pair.

import type {
  TeacherIllustration,
  TeacherStructure,
  TeacherVoice1,
  TeacherVoice2,
} from "../creator-profile/dnaOptions";

export interface TeacherAnswers {
  voice1: TeacherVoice1 | null;
  voice2: TeacherVoice2 | null;
  illustration: TeacherIllustration | null;
  structure: TeacherStructure | null;
  depth: number;
  autonomy: number;
  guardrail: string;
}

export const TEACHER_STEPS = [
  "welcome",
  "voice1",
  "voice2",
  "illustration",
  "structure",
  "depth",
  "autonomy",
  "guardrail",
  "finish",
] as const;

export type TeacherStep = (typeof TEACHER_STEPS)[number];

export interface TeacherOnboardingState {
  answers: TeacherAnswers;
  currentStep: TeacherStep;
}
